import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { InsuranceTemplate } from '@models/InsuranceTemplate';
import { API_V1_BASE } from '@config';

export class InsuranceTemplateApi {
  static getAll = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/insurance_templates`)
      .then((response) => humps(response.data) as InsuranceTemplate[]);
  };
}
